import React, { useContext, useState, useEffect } from 'react'
import ImageGallery from './ImageGallery'
import './Story.css'
import UserContext from '../context/UserContext'
import { updateStory } from '../helpers/StoryFunctions'
import { useParams } from 'react-router-dom'
import Linkify from 'linkify-react';


export default function Story(props) {

  const { isAuthenticated } = useContext(UserContext)
  const { id } = useParams()

  const {header, content} = props

  const [isEditing, setIsEditing] = useState(false)
  const [editingHeader, setEditingHeader] = useState(header)
  const [editingContent, setEditingContent] = useState(content)

  const handleSave = async () => {
    await updateStory(id, editingHeader, editingContent)
    setIsEditing(false)

    if (props.onUpdate) {
      props.onUpdate()
    }
  }

  useEffect(() => {
    setEditingHeader(props.header)
    setEditingContent(props.content)
  }, [props.header, props.content])

  return (
    <div>
      <div className='editButtonContainer'>
        {isAuthenticated && !isEditing && <button className='editButton' onClick={() => setIsEditing(true)}>Edit</button>}
        {isAuthenticated && isEditing && <button className='editButton' onClick={() => handleSave()}>Save</button>}
      </div>
      {isEditing ? (
        <>
          <p>Edit header</p>
          <textarea
            name='storyHeader'
            className='storyTextarea'
            value={editingHeader}
            onChange={e => setEditingHeader(e.target.value)}
          />
          <p>Edit story</p>
          <textarea
            name='storyContent'
            className='storyTextarea'
            value={editingContent}
            onChange={e => setEditingContent(e.target.value)}
          />
        </>
      ) : (
        <>
          {props.header ? (<h1>{props.header}</h1>) : <h4>No header</h4>}
          {props.images ? (<img className="headerImage" src={props.images[0]} alt=''></img>) : (<img className="headerImage" src='https://placehold.co/600x400/png' alt=''></img>)}
          {props.content ? (<p className='storyText'><Linkify>{editingContent}</Linkify></p>) : (<p className='storyText'>No content here</p>)}
          <ImageGallery images={props.images}></ImageGallery>
        </>
      )}
    </div>
  )
}
